import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Restricted from '../../common/restricted'

import RequirementList from '../rider-requirements/requirement-list/list'

class Requirements extends Component {
  render() {
    const { view, rider } = this.props

    return (
      <section className="requirements">
        <div className="section-head">
          <h2>Hospitality</h2>
        </div>

        {
          view.loggedIn
          ? <RequirementList
              view={view}
              requirements={{
                group: 'hospitality',
                class: 'requirement',
                title: 'Hospitality requirement'
              }}
              items={rider.hospitality}
              addRiderItem={this.props.addRiderItem}
              removeRiderItem={this.props.removeRiderItem}
              createRiderItem={this.props.createRiderItem}
              editRiderItem={this.props.editRiderItem}
              moveRiderItem={this.props.moveRiderItem}
              deleteRiderItem={this.props.deleteRiderItem} />
          : <Restricted
              section="Hospitality"
              setModal={this.props.setModal} />
        }
      </section>
    )
  }
}

Requirements.propTypes = {
  view: PropTypes.object,
  rider: PropTypes.object,
  addRiderItem: PropTypes.func,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func,
  moveRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  setModal: PropTypes.func
}

Requirements.defaultProps = {
  view: {},
  rider: {},
  addRiderItem: function() {},
  removeRiderItem: function() {},
  createRiderItem: function() {},
  editRiderItem: function() {},
  moveRiderItem: function() {},
  deleteRiderItem: function() {},
  setModal: function() {}
}

export default Requirements



// WEBPACK FOOTER //
// ./src/components/rider/rider-hospitality/hospitality.js